import DataTable, {Order} from "datatables.net-bs5";
import {AjaxData} from "datatables.net";
import * as Highcharts from "highcharts";
import flatpickr from "flatpickr";
import {on} from "../util";
import { getChartTheme } from "../utils/chartTheme";
declare const eo_version : string;
declare const mobs_array : any[];
declare const mobs_gold_array : any[];
declare const mobs_exp_array : any[];
declare const items_array : any[];
declare const items_gold_array : any[];
declare const items_exp_array : any[];
declare const dates_array : string[];
declare const interval : number;
declare const my_day_date : string;
// D-A1 — PHP-owns-DST / JS-goes-dumb contract: the server-computed
// America/Toronto-day-boundary epoch-ms (PersonalModel::getDayHistory).
// Only present on the My Day page (my_day_history.latte); the shared
// out-of-scope my_kills_history.latte (2h-rolling page) does not emit it —
// see the `typeof point_start !== 'undefined'` fallback below (Pitfall 5).
declare const point_start : number;

interface SourceAjaxData extends AjaxData {
    source : string
}

// Plain YYYY-MM-DD string — the current My Day page date. Never round-tripped
// through a Date-object-and-back-to-string conversion (D-A2); Date.UTC() is
// used ONLY as a throwaway calendar-arithmetic scratch value inside
// addDaysToYmd().
let currentDayYmd : string;

export default class {
    static init = () => {
        init_date();
        my_kills();
        my_kills_history();
        my_gathered();
        my_gathering_history();
        my_day();
    }
}

function init_date() {
    if(typeof my_day_date !== 'undefined') {
        currentDayYmd = my_day_date;
    } else {
        const now = new Date();
        currentDayYmd = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
    }
}

// D-A2 — plain YYYY-MM-DD string arithmetic. Date.UTC(y, m-1, d+delta) is used
// ONLY as a scratch value to let the JS Date engine handle month/year
// rollover; the result is immediately read back via the UTC getters and
// reformatted to YYYY-MM-DD. Never rendered, never compared to chart data.
function addDaysToYmd(ymd : string, delta : number) : string {
    const [y, m, d] = ymd.split('-').map(Number);
    const scratch = new Date(Date.UTC(y, m - 1, d + delta));
    const yyyy = scratch.getUTCFullYear();
    const mm = String(scratch.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(scratch.getUTCDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}

function my_kills() {
    let table = document.querySelector('.datatable[data-table="my_kills"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="my_kills"]',{
        pageLength: 10,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        responsive: true,
        ajax: {
            url: '?do=getMyKills',
            data: function(data : SourceAjaxData) {
                let sourceSelect = document.querySelector('.js-eo-source-filter') as HTMLSelectElement;
                data.source = sourceSelect ? sourceSelect.value : 'all';
                return data;
            }
        },
        columns: [
            { data: null, className: "align-middle", render: function(data) {
                    return `<div class="text-center"><a href="/eo/mobs/${data.npc_id}"><img src="/assets/eo/${eo_version}/npc/${data.npc_id}.png" class="eo-item-image-medium" /><div>${data.mob}</div></a></div>`;
                }},
            { data: 'kills', className: "align-middle" },
            { data: 'exp', className: "align-middle" },
            { data: null, className: "align-middle td-drops", render: function(data : any) {
                    if(data.drops.length == 0) {
                        return '-';
                    }
                    let dropsDiv = document.createElement('div');
                    dropsDiv.className = 'table-drops';
                    data.drops.forEach((drop : any) => {
                        let dropDiv = document.createElement('div');
                        dropDiv.className = 'table-drop';
                        dropDiv.innerHTML = `<img src="/assets/eo/${eo_version}/items/${drop.id}.png" class="eo-item-image-small" /> <a href="/eo/items/${drop.id}">${drop.name}</a> x ${drop.count} <small>(${drop.rate}%)</small>`;
                        dropsDiv.appendChild(dropDiv);
                    });
                    return dropsDiv.outerHTML;
                }, width: '18%' },
            { data: 'total_gold', className: "align-middle" },
            { data: 'avg_gold', className: "align-middle" },
            { data: 'ttk', className: "align-middle" },
            { data: 'time', className: "align-middle" },
            { data: 'kills_hour', className: "align-middle" },
            { data: 'hour_gold', className: "align-middle" },
            { data: 'hour_exp', className: "align-middle" },
        ],
        order: [[1,"desc"]] as Order[]
    });

    on('change', '.js-eo-source-filter', () => {
        datatable.ajax.reload(() => {},false);
    });
}

function my_gathered() {
    let table = document.querySelector('.datatable[data-table="my_gathered"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="my_gathered"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        responsive: true,
        ajax: {
            url: '?do=getMyGathering',
            data: function(data : SourceAjaxData) {
                let sourceSelect = document.querySelector('.js-eo-source-filter') as HTMLSelectElement;
                data.source = sourceSelect ? sourceSelect.value : 'all';
                return data;
            }
        },
        columns: [
            { data: null, className: "align-middle", render: function(data) {
                    return `<img src="/assets/eo/${eo_version}/items/${data.item_id}.png" class="eo-item-image-small" /> <a href="/eo/items/${data.item_id}">${data.item}</a>`;
                }},
            { data: 'gathered', className: "align-middle" },
            { data: 'exp', className: "align-middle" },
            { data: 'total_gold', className: "align-middle" },
            { data: 'avg_gold', className: "align-middle" },
            { data: 'ttg', className: "align-middle" },
            { data: 'gathered_hour', className: "align-middle" },
            { data: 'hour_gold', className: "align-middle" },
        ],
        order: [[1,"desc"]] as Order[]
    });

    on('change', '.js-eo-source-filter', () => {
        datatable.ajax.reload(() => {},false);
    });
}

function my_kills_history() {
    let chart : Highcharts.Chart;

    if(typeof mobs_array !== 'undefined') {
        const button_background = getComputedStyle(document.documentElement).getPropertyValue('--ksat-surface-raised').trim();
        let gold_color = 'rgb(255, 255, 0, 0.3)';
        let exp_color = 'rgb(65,211,255,0.3)';

        let series: Highcharts.SeriesOptionsType[] = [];
        //@ts-ignore
        series.push({
            type: 'spline',
            name: 'Profit',
            data: mobs_gold_array,
            visible: true,
            yAxis: 1,
            color: 'rgb(255, 255, 0, 0.3)',
            showInLegend: false,
            tooltip: {
                valueSuffix: ' eons',
            }
        });
        //@ts-ignore
        series.push({
            type: 'spline',
            name: 'Experience',
            data: mobs_exp_array,
            visible: true,
            yAxis: 2,
            color: exp_color,
            showInLegend: false,
            tooltip: {
                valueSuffix: ' exp',
            }
        });
        mobs_array.forEach((mob) => {
            let data = mob.data;
            //@ts-ignore
            series.push({
                type: 'column',
                name: mob.name,
                data: data,
                visible: true,
                // connectNulls: true,
                color: mob.color
            });
        });

        // @ts-ignore
        chart = Highcharts.chart("chart_eo_kill_history", Highcharts.merge(getChartTheme(), {
            series: series as Highcharts.SeriesOptionsType[],
            chart: {
                height: 500,
                zooming: {
                    type: 'x',
                    resetButton: {
                        position: {
                            align: "right",
                            x: 0,
                            y: -30
                        },
                        theme: {
                            fill: button_background,
                            stroke: "none",
                            style: {
                                backgroundColor: button_background
                            },
                            states: {
                                hover: {
                                    fill: button_background,
                                    style: {
                                        backgroundColor: button_background
                                    }
                                }
                            }
                        }
                    }
                },
            },
            title: {
                text: 'My Kills History',
                // align: 'left',
                style: {
                    fontSize: '14px'
                }
            },
            legend: {
                enabled: true,
            },
            //@ts-ignore
            xAxis: {
                type: 'datetime',
                // 24h axis ticks (tooltips are already 24h) — without this the
                // en-CA Intl locale (src/index.ts lang.locale:'en-CA') renders
                // 12h AM/PM tick labels. The global UTC time option (src/index.ts) stays untouched.
                dateTimeLabelFormats: { hour: '%H:%M', minute: '%H:%M', day: '%e %b' },
                labels: {
                    overflow: 'justify',
                }
            },
            yAxis: [{
                title: {
                    text: '',
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
                // @ts-ignore
                alternateGridColor: null,
                allowDecimals: false
            },{
                type: 'linear',
                title: {
                    text: '',
                    style: {
                        color: gold_color
                    }
                },
                labels: {
                    style: {
                        color: gold_color
                    }
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
            },{
                type: 'linear',
                title: {
                    text: '',
                    style: {
                        color: exp_color
                    }
                },
                labels: {
                    style: {
                        color: exp_color
                    }
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
            }],
            tooltip: {
                valueSuffix: ' kills',
                xDateFormat: '%b %e, %Y %H:%M'
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    borderWidth: 0,
                    states: {
                        hover: {
                            borderWidth: 1,
                        }
                    },
                    pointInterval: interval,
                    // D-A1 — server-supplied point_start (correct UTC instant, no JS
                    // TZ arithmetic). Fallback keeps the shared out-of-scope
                    // my_kills_history 2h-rolling page functioning (Pitfall 5) — a
                    // regression guard, not a fix, since it emits no point_start.
                    pointStart: (typeof point_start !== 'undefined') ? point_start : Date.parse(dates_array[0]),
                },
                spline: {
                    lineWidth: 2,
                    states: {
                        hover: {
                            lineWidth: 3
                        }
                    },
                    marker: {
                        enabled: false
                    },
                    pointInterval: interval,
                    // D-A1 — server-supplied point_start (correct UTC instant, no JS
                    // TZ arithmetic). Fallback keeps the shared out-of-scope
                    // my_kills_history 2h-rolling page functioning (Pitfall 5) — a
                    // regression guard, not a fix, since it emits no point_start.
                    pointStart: (typeof point_start !== 'undefined') ? point_start : Date.parse(dates_array[0]),
                },
            },
            credits: {
                enabled: false
            }
        } as any) as Highcharts.Chart);
    }
}

function my_gathering_history() {
    let chart : Highcharts.Chart;

    if(typeof items_array !== 'undefined') {
        const button_background = getComputedStyle(document.documentElement).getPropertyValue('--ksat-surface-raised').trim();
        let gold_color = 'rgb(255, 255, 0, 0.3)';
        let exp_color = 'rgb(65,211,255,0.3)';

        let series: Highcharts.SeriesOptionsType[] = [];
        //@ts-ignore
        series.push({
            type: 'spline',
            name: 'Profit',
            data: items_gold_array,
            visible: true,
            yAxis: 1,
            color: gold_color,
            showInLegend: false,
            tooltip: {
                valueSuffix: ' eons',
            }
        });
        //@ts-ignore
        series.push({
            type: 'spline',
            name: 'Experience',
            data: items_exp_array,
            visible: true,
            yAxis: 2,
            color: exp_color,
            showInLegend: false,
            tooltip: {
                valueSuffix: ' exp',
            }
        });
        items_array.forEach((item) => {
            let data = item.data;
            series.push({
                type: 'column',
                name: item.name,
                data: data,
                visible: true,
                // connectNulls: true,
                color: item.color
            });
        });

        chart = Highcharts.chart("chart_eo_gathering_history", Highcharts.merge(getChartTheme(), {
            series: series as Highcharts.SeriesOptionsType[],
            chart: {
                height: 500,
                zooming: {
                    type: 'x',
                    resetButton: {
                        position: {
                            align: "right",
                            x: 0,
                            y: -30
                        },
                        theme: {
                            fill: button_background,
                            stroke: "none",
                            style: {
                                backgroundColor: button_background
                            },
                            states: {
                                hover: {
                                    fill: button_background,
                                    style: {
                                        backgroundColor: button_background
                                    }
                                }
                            }
                        }
                    }
                },
            },
            title: {
                text: 'My Gathering History',
                // align: 'left',
                style: {
                    fontSize: '14px'
                }
            },
            legend: {
                enabled: true,
            },
            //@ts-ignore
            xAxis: {
                type: 'datetime',
                // 24h axis ticks (tooltips are already 24h) — without this the
                // en-CA Intl locale (src/index.ts lang.locale:'en-CA') renders
                // 12h AM/PM tick labels. The global UTC time option (src/index.ts) stays untouched.
                dateTimeLabelFormats: { hour: '%H:%M', minute: '%H:%M', day: '%e %b' },
                labels: {
                    overflow: 'justify',
                }
            },
            yAxis: [{
                title: {
                    text: '',
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
                // @ts-ignore
                alternateGridColor: null,
                allowDecimals: false
            },{
                type: 'linear',
                title: {
                    text: '',
                    style: {
                        color: gold_color
                    }
                },
                labels: {
                    style: {
                        color: gold_color
                    }
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
            },{
                type: 'linear',
                title: {
                    text: '',
                    style: {
                        color: exp_color
                    }
                },
                labels: {
                    style: {
                        color: exp_color
                    }
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
            }],
            tooltip: {
                valueSuffix: ' collected',
                xDateFormat: '%b %e, %Y %H:%M'
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    borderWidth: 0,
                    states: {
                        hover: {
                            borderWidth: 1,
                        }
                    },
                    pointInterval: interval,
                    // D-A1 — server-supplied point_start (correct UTC instant, no JS
                    // TZ arithmetic). Fallback keeps the shared out-of-scope
                    // my_kills_history 2h-rolling page functioning (Pitfall 5) — a
                    // regression guard, not a fix, since it emits no point_start.
                    pointStart: (typeof point_start !== 'undefined') ? point_start : Date.parse(dates_array[0]),
                },
                spline: {
                    lineWidth: 2,
                    states: {
                        hover: {
                            lineWidth: 3
                        }
                    },
                    marker: {
                        enabled: false
                    },
                    pointInterval: interval,
                    // D-A1 — server-supplied point_start (correct UTC instant, no JS
                    // TZ arithmetic). Fallback keeps the shared out-of-scope
                    // my_kills_history 2h-rolling page functioning (Pitfall 5) — a
                    // regression guard, not a fix, since it emits no point_start.
                    pointStart: (typeof point_start !== 'undefined') ? point_start : Date.parse(dates_array[0]),
                }
            },
            credits: {
                enabled: false
            }
        } as any) as Highcharts.Chart);
    }
}

function my_day() {
    if(typeof items_array === 'undefined' && typeof mobs_array === 'undefined') {
        return;
    }

    on('click', '.js-eo-day-prev', () => {
        goto(addDaysToYmd(currentDayYmd, -1));
    });

    on('click', '.js-eo-day-next', () => {
        goto(addDaysToYmd(currentDayYmd, 1));
    });

    // D-B2 — My Day is a full-page-reload nav (chart data is baked at render
    // time), so the source selector reloads the page with the source param
    // instead of an ajax reload (mirrors the Prev/Next day buttons).
    on('change', '.js-eo-source-filter', () => {
        goto(currentDayYmd);
    });

    // Calendar date picker — jump straight to any chosen day. Custom flatpickr
    // init (not the shared [data-picker="date"] path) because we need an
    // onChange that navigates — same pattern as src/js/mc/analytics.ts. The
    // input therefore carries NO data-picker attr, so shared initPickers() skips
    // it and there is no double-init. goto() is hoisted (function declaration).
    const dateInput = document.querySelector('.js-eo-date-picker') as HTMLInputElement | null;
    if(dateInput && !(dateInput as any)._flatpickr) {
        flatpickr(dateInput, {
            dateFormat: 'Y-m-d',       // LOCKED — matches the route <date> regex + PHP side
            defaultDate: currentDayYmd,
            onChange: (_selectedDates, dateStr) => {
                if(dateStr && dateStr !== currentDayYmd) {
                    goto(dateStr);
                }
            },
        });
    }

    function goto(newDayYmd : string) {
        let sourceSelect = document.querySelector('.js-eo-source-filter') as HTMLSelectElement;
        let source = sourceSelect ? sourceSelect.value : 'all';
        let url = '/eo/my-day/history/' + newDayYmd;
        if(source && source !== 'all') {
            url += '?source=' + source;
        }
        window.location.href = url;
    }
}
